import { useEffect, useState } from "react";
import { SUPABASE_URL } from "./supabase";

const FN = `${SUPABASE_URL}/functions/v1/factura-publica`;
const B = { blue:"#1b57ce", blueL:"#e8f0fd", amber:"#d97706", green:"#16a34a", muted:"#6b7280", text:"#111827" };

export default function SubirFactura() {
  const token = new URLSearchParams(window.location.search).get("t") || "";
  const [estado, setEstado] = useState("cargando"); // cargando | listo | subida | invalido | exito
  const [pkg, setPkg] = useState(null);
  const [subiendo, setSubiendo] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!token) { setEstado("invalido"); return; }
    fetch(`${FN}?t=${encodeURIComponent(token)}`)
      .then(async r => {
        if (!r.ok) { setEstado("invalido"); return; }
        const d = await r.json();
        setPkg(d);
        if (d.valor) setMonto(String(d.valor));
        setEstado(d.necesita ? "listo" : "subida");
      })
      .catch(() => setEstado("invalido"));
  }, [token]);

  const [files, setFiles] = useState([]);
  const [monto, setMonto] = useState("");
  const OK = f => f.type.startsWith("image/") || f.type === "application/pdf" || /\.(heic|pdf)$/i.test(f.name);

  function agregar(list) {
    setErr("");
    const nuevos = [];
    for (const f of Array.from(list || [])) {
      if (f.size > 10 * 1024 * 1024) { setErr("Un archivo supera 10MB y no se agregó."); continue; }
      if (!OK(f)) { setErr("Solo fotos (JPG, PNG) o PDF."); continue; }
      nuevos.push(f);
    }
    setFiles(prev => [...prev, ...nuevos].slice(0, 10));
  }

  async function subir() {
    if (!files.length) return;
    setErr("");
    const m = parseFloat(String(monto).replace(",", "."));
    if (!isFinite(m) || m <= 0) { setErr("Indica el monto total de tu compra en dólares."); return; }
    setSubiendo(true);
    try {
      const fd = new FormData();
      fd.append("t", token);
      fd.append("valor", String(m));
      files.forEach(f => fd.append("file", f));
      const r = await fetch(FN, { method:"POST", body: fd });
      const d = await r.json().catch(() => ({}));
      if (r.ok) setEstado("exito");
      else if (d.error === "ya_subida") setEstado("subida");
      else if (d.error === "monto_requerido") setErr("Indica el monto total de tu compra en dólares.");
      else if (d.error === "tipo_no_permitido") setErr("Sube fotos (JPG, PNG) o PDF.");
      else setErr("No pudimos subir los archivos. Intenta de nuevo.");
    } catch { setErr("Sin conexión. Intenta de nuevo."); }
    setSubiendo(false);
  }

  const card = { background:"#fff", borderRadius:20, padding:"32px 28px", boxShadow:"0 4px 24px rgba(27,87,206,0.10)", width:"100%", maxWidth:440, textAlign:"center", boxSizing:"border-box" };
  const box = { background:"#fffbeb", border:"1px solid #fde68a", borderRadius:12, padding:14, margin:"18px 0", textAlign:"left" };

  return (
    <div style={{ minHeight:"100vh", background:"#f0f4ff", display:"flex", alignItems:"center", justifyContent:"center", padding:16, fontFamily:"'Helvetica Neue',Arial,sans-serif" }}>
      <div style={card}>
        <img src="/favicon.png" alt="Flashbox" width="64" style={{ height:"auto", marginBottom:8 }} onError={e => e.currentTarget.style.display="none"}/>
        {estado === "cargando" && <p style={{ color:B.muted }}>Cargando…</p>}

        {estado === "invalido" && (<>
          <h2 style={{ color:B.text, margin:"8px 0" }}>Link no válido</h2>
          <p style={{ color:B.muted, fontSize:14 }}>Este link no existe o ya no está disponible. Si necesitas ayuda escríbenos por WhatsApp.</p>
        </>)}

        {estado === "subida" && (<>
          <div style={{ fontSize:40 }}>✅</div>
          <h2 style={{ color:B.text, margin:"8px 0" }}>Ya tenemos tu factura</h2>
          <p style={{ color:B.muted, fontSize:14 }}>{pkg?.verificada ? <>Tu factura de <b>{pkg?.id}</b> ya fue verificada: tu paquete está listo para volar ✈️.</> : <>Tu factura de <b>{pkg?.id}</b> está siendo verificada para que tu paquete pueda volar ✈️. No necesitas hacer nada más.</>}</p>
          <a href="/portal" style={{ color:B.blue, fontWeight:700, fontSize:14 }}>Ir a mi portal</a>
        </>)}

        {estado === "exito" && (<>
          <div style={{ fontSize:40 }}>🎉</div>
          <h2 style={{ color:B.text, margin:"8px 0" }}>¡Factura recibida!</h2>
          <p style={{ color:B.muted, fontSize:14 }}>Gracias. Hemos recibido tu factura del paquete <b>{pkg?.id}</b>. Está siendo verificada para que pueda volar ✈️. Te avisaremos por correo cuando esté lista.</p>
          <a href="/portal" style={{ color:B.blue, fontWeight:700, fontSize:14 }}>Ir a mi portal</a>
        </>)}

        {estado === "listo" && (<>
          <h2 style={{ color:B.text, margin:"8px 0" }}>{pkg?.atencion ? "Tu paquete requiere tu atención" : "Sube tu factura"}</h2>
          <p style={{ color:B.muted, fontSize:14, margin:0 }}>{pkg?.atencion ? "Necesitamos tu ayuda para que tu paquete pueda volar ✈️" : "Necesitamos la factura para que tu paquete pueda volar ✈️"}</p>
          {pkg?.atencion && pkg?.nota && (
            <div style={{ background:"#fff7ed", border:"1px solid #fed7aa", borderRadius:12, padding:"12px 14px", margin:"14px 0 0", textAlign:"left" }}>
              <div style={{ fontSize:11, fontWeight:800, color:"#9a3412", marginBottom:3 }}>NOTA DE FLASHBOX</div>
              <div style={{ fontSize:14, color:"#374151", whiteSpace:"pre-wrap" }}>{pkg.nota}</div>
            </div>
          )}
          <div style={box}>
            <div style={{ fontSize:12, color:B.muted }}>Código de paquete</div>
            <div style={{ fontSize:17, fontWeight:800, color:B.amber }}>{pkg?.id}</div>
            {pkg?.descripcion && <div style={{ fontSize:13, color:"#374151", marginTop:4 }}>{pkg.descripcion}</div>}
          </div>
          {files.length > 0 && (
            <div style={{ textAlign:"left", marginBottom:12 }}>
              {files.map((f,i) => (
                <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", background:B.blueL, borderRadius:8, padding:"8px 12px", marginBottom:6, fontSize:13 }}>
                  <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"80%" }}>📄 {f.name}</span>
                  <button disabled={subiendo} onClick={() => setFiles(files.filter((_,j) => j!==i))} style={{ border:"none", background:"none", color:"#dc2626", fontWeight:800, cursor:"pointer", fontSize:16 }}>✕</button>
                </div>
              ))}
            </div>
          )}
          <label style={{ display:"block", background:files.length?"#fff":B.blue, color:files.length?B.blue:"#fff", border:files.length?`2px dashed ${B.blue}`:"none", padding:"14px 20px", borderRadius:12, fontWeight:800, fontSize:15, cursor:"pointer", marginBottom:10 }}>
            {files.length ? "+ Agregar otra factura" : "📎 Elegir factura (foto o PDF)"}
            <input type="file" multiple accept="image/*,application/pdf" disabled={subiendo} style={{ display:"none" }} onChange={e => { agregar(e.target.files); e.target.value=""; }}/>
          </label>
          <div style={{ textAlign:"left", margin:"6px 0 14px" }}>
            <div style={{ fontSize:12, fontWeight:700, color:"#374151", marginBottom:4 }}>Monto total de tu compra (USD) *</div>
            <input type="number" inputMode="decimal" min="0" step="0.01" placeholder="Ej. 85.50" value={monto} onChange={e => setMonto(e.target.value)} disabled={subiendo}
              style={{ width:"100%", boxSizing:"border-box", border:"1.5px solid #d1d5db", borderRadius:10, padding:"11px 12px", fontSize:15, fontFamily:"inherit" }}/>
            <div style={{ fontSize:11, color:B.muted, marginTop:4 }}>Si hay varias facturas, suma todas. Verificaremos que coincida con tus facturas.</div>
          </div>
          {files.length > 0 && (
            <button onClick={subir} disabled={subiendo} style={{ width:"100%", background:subiendo?"#94a3b8":B.green, color:"#fff", border:"none", padding:"14px 20px", borderRadius:12, fontWeight:800, fontSize:15, cursor:subiendo?"default":"pointer" }}>
              {subiendo ? "Enviando…" : `Enviar ${files.length} factura${files.length>1?"s":""}`}
            </button>
          )}
          {err && <p style={{ color:"#dc2626", fontSize:13, marginTop:12 }}>{err}</p>}
          <p style={{ color:B.muted, fontSize:12, marginTop:14 }}>Si tu paquete trae varias compras, agrega todas las facturas y luego presiona Enviar. Máx. 10MB c/u.</p>
        </>)}
      </div>
    </div>
  );
}
